"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Tue Oct 09 2018
 */

var immutable_1 = require("immutable");

var StructPropBuilder_1 = require("../../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../../core/model/DomainObject");

var CompetitorProductBindDTO_1 = require("./CompetitorProductBindDTO");
/**
 * Data transfer object describing row in main Data pairing page(overview of recommended),
 *
 * @author RV
 */


var BindDTO =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(BindDTO, _DomainObject_1$Domai);

  /**
   *
   * @param internalProductId
   * @param binds list of DTOs containing id of competitor product with sizeRatio and sizecharger
   */
  function BindDTO(internalProductId) {
    var _this;

    var binds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : immutable_1.List();

    _classCallCheck(this, BindDTO);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(BindDTO).call(this));
    _this.internalProductId = internalProductId;
    _this.binds = binds;
    return _this;
  }

  return BindDTO;
}(DomainObject_1.DomainObject);

exports.BindDTO = BindDTO; // tslint:disable-next-line:member-ordering

BindDTO.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(BindDTO.name);
  return {
    internalProductId: builder.id('internalProductId'),
    binds: builder.listOf(builder.obj(CompetitorProductBindDTO_1.CompetitorProductBindDTO.name, CompetitorProductBindDTO_1.CompetitorProductBindDTO.schema, function (mat) {
      return new CompetitorProductBindDTO_1.CompetitorProductBindDTO(mat.id, mat.ratio, mat.charger);
    }))
  };
}();